import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageContainer from '../components/shared/page/PageContainer';
import PageNavigateTitle from '../components/shared/page/PageNavigateTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import Tabs from '../components/shared/tabs/Tabs';
import VisitImageContainer from '../components/visit/images/VisitImageContainer';
import VisitPartsHeader from '../components/visit/parts/VisitPartsHeader';
import VisitPartsList from '../components/visit/parts/VisitPartsList';
import VisitTasksHeader from '../components/visit/tasks/VisitTasksHeader';
import VisitTasksList from '../components/visit/tasks/VisitTasksList';
import VisitActions from '../components/visit/VisitActions';
import VisitInfo from '../components/visit/VisitInfo';
import VisitsHeader from '../components/visit/VisitsHeader';
import useFetchVisit from '../hooks/visit/useFetchVisit';

const Visit = () => {
  const { vin, visitId } = useParams();
  const { visit, loading } = useFetchVisit(visitId, vin);
  const userData = useSelector((state) => state.auth.userData);

  const readOnly = loading || !visit.isOwner || visit.isFinished || !userData?.roles.includes(ROLE_VEHICLE_MANAGER);

  const tabs = [
    {
      label: 'ПОСЛУГИ',
      content: (
        <PageContainer className="mt-2 md:mt-4">
          <Container>
            <VisitTasksHeader readOnly={readOnly} />
            <VisitTasksList readOnly={readOnly} />
          </Container>
        </PageContainer>
      ),
    },
    {
      label: 'ДЕТАЛІ',
      content: (
        <PageContainer className="mt-2 md:mt-4">
          <Container>
            <VisitPartsHeader readOnly={readOnly} />
            <VisitPartsList readOnly={readOnly} />
          </Container>
        </PageContainer>
      ),
    },
    {
      label: 'ФОТО',
      content: <VisitImageContainer readOnly={readOnly} />,
    },
  ];

  return (
    <Suspense fallback={<CommonLoader />}>
      {loading ? (
        <CommonLoader />
      ) : (
        <section>
          <PageTitleContainer>
            <PageNavigateTitle title={`№${visit.id}`} link={`/vehicles/${vin}`} />
            <VisitActions readOnly={readOnly} />
          </PageTitleContainer>
          <PageContainer className="mt-2 md:mt-4">
            <Container className="col-span-2 lg:col-span-1">
              <VisitsHeader readOnly={readOnly} />
              <VisitInfo />
            </Container>
          </PageContainer>
          <Tabs tabs={tabs} />
        </section>
      )}
    </Suspense>
  );
};

export default Visit;
